"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typography = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
/* eslint-disable max-lines */
/* eslint-disable sort-keys */

// Tell Material-UI what's the font-size on the html element.
// 16px is the default font-size used by browsers.
var htmlFontSize = 16; // 16 default
var pxToRem = function pxToRem(size) {
  return "".concat(size / htmlFontSize, "rem");
};
var color = '#121926';
var fontFamily = 'Inter';
var fontSize = 14;
var fontStyle = 'normal';
var fontWeightLight = 300;
var fontWeightRegular = 400;
var fontWeightMedium = 500;
var fontWeightSemiBold = 600;
var fontWeightBold = 700;
var baseValues = {
  color: color,
  fontFamily: fontFamily,
  fontSize: fontSize,
  fontStyle: fontStyle,
  fontWeightBold: fontWeightBold,
  fontWeightLight: fontWeightLight,
  fontWeightMedium: fontWeightMedium,
  fontWeightRegular: fontWeightRegular,
  fontWeightSemiBold: fontWeightSemiBold,
  htmlFontSize: htmlFontSize,
  pxToRem: pxToRem
};
var typographyVariants = {
  'display-2xl-regular': {
    fontSize: '72px',
    fontWeight: 400,
    letterSpacing: '-1.44px',
    lineHeight: '90px'
  },
  'display-2xl-medium': {
    fontSize: '72px',
    fontWeight: 500,
    letterSpacing: '-1.44px',
    lineHeight: '90px'
  },
  'display-2xl-light': {
    fontSize: '72px',
    fontWeight: 300,
    letterSpacing: '-1.44px',
    lineHeight: '90px'
  },
  'display-2xl-semibold': {
    fontSize: '72px',
    fontWeight: 600,
    letterSpacing: '-1.44px',
    lineHeight: '90px'
  },
  'display-2xl-bold': {
    fontSize: '72px',
    fontWeight: 700,
    letterSpacing: '-1.44px',
    lineHeight: '90px'
  },
  'display-xl-regular': {
    fontSize: '60px',
    fontWeight: 400,
    letterSpacing: '-1.2px',
    lineHeight: '72px'
  },
  'display-xl-medium': {
    fontSize: '60px',
    fontWeight: 500,
    letterSpacing: '-1.2px',
    lineHeight: '72px'
  },
  'display-xl-light': {
    fontSize: '60px',
    fontWeight: 300,
    letterSpacing: '-1.2px',
    lineHeight: '72px'
  },
  'display-xl-semibold': {
    fontSize: '60px',
    fontWeight: 600,
    letterSpacing: '-1.2px',
    lineHeight: '72px'
  },
  'display-xl-bold': {
    fontSize: '60px',
    fontWeight: 700,
    letterSpacing: '-1.2px',
    lineHeight: '72px'
  },
  'display-lg-regular': {
    fontSize: '48px',
    fontWeight: 400,
    letterSpacing: '-0.96px',
    lineHeight: '60px'
  },
  'display-lg-medium': {
    fontSize: '48px',
    fontWeight: 500,
    letterSpacing: '-0.96px',
    lineHeight: '60px'
  },
  'display-lg-light': {
    fontSize: '48px',
    fontWeight: 300,
    letterSpacing: '-0.96px',
    lineHeight: '60px'
  },
  'display-lg-semibold': {
    fontSize: '48px',
    fontWeight: 600,
    letterSpacing: '-0.96px',
    lineHeight: '60px'
  },
  'display-lg-bold': {
    fontSize: '48px',
    fontWeight: 700,
    letterSpacing: '-0.96px',
    lineHeight: '60px'
  },
  'display-md-regular': {
    fontSize: '36px',
    fontWeight: 400,
    letterSpacing: '-0.72px',
    lineHeight: '44px'
  },
  'display-md-medium': {
    fontSize: '36px',
    fontWeight: 500,
    letterSpacing: '-0.72px',
    lineHeight: '44px'
  },
  'display-md-light': {
    fontSize: '36px',
    fontWeight: 300,
    letterSpacing: '-0.72px',
    lineHeight: '44px'
  },
  'display-md-semibold': {
    fontSize: '36px',
    fontWeight: 600,
    letterSpacing: '-0.72px',
    lineHeight: '44px'
  },
  'display-md-bold': {
    fontSize: '36px',
    fontWeight: 700,
    letterSpacing: '-0.72px',
    lineHeight: '44px'
  },
  'display-sm-regular': {
    fontSize: '30px',
    fontWeight: 400,
    lineHeight: '38px'
  },
  'display-sm-medium': {
    fontSize: '30px',
    fontWeight: 500,
    lineHeight: '38px'
  },
  'display-sm-light': {
    fontSize: '30px',
    fontWeight: 300,
    lineHeight: '38px'
  },
  'display-sm-semibold': {
    fontSize: '30px',
    fontWeight: 600,
    lineHeight: '38px'
  },
  'display-sm-bold': {
    fontSize: '30px',
    fontWeight: 700,
    lineHeight: '38px'
  },
  'display-xs-regular': {
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: '32px'
  },
  'display-xs-medium': {
    fontSize: '24px',
    fontWeight: 500,
    lineHeight: '32px'
  },
  'display-xs-light': {
    fontSize: '24px',
    fontWeight: 300,
    lineHeight: '32px'
  },
  'display-xs-semibold': {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: '32px'
  },
  'display-xs-bold': {
    fontSize: '24px',
    fontWeight: 700,
    lineHeight: '32px'
  },
  'text-xl-regular': {
    fontSize: '20px',
    fontWeight: 400,
    lineHeight: '30px'
  },
  'text-xl-medium': {
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: '30px'
  },
  'text-xl-light': {
    fontSize: '20px',
    fontWeight: 300,
    lineHeight: '30px'
  },
  'text-xl-semibold': {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: '30px'
  },
  'text-xl-bold': {
    fontSize: '20px',
    fontWeight: 700,
    lineHeight: '30px'
  },
  'text-lg-regular': {
    fontSize: '18px',
    fontWeight: 400,
    lineHeight: '28px'
  },
  'text-lg-medium': {
    fontSize: '18px',
    fontWeight: 500,
    lineHeight: '28px'
  },
  'text-lg-light': {
    fontSize: '18px',
    fontWeight: 300,
    lineHeight: '28px'
  },
  'text-lg-semibold': {
    fontSize: '18px',
    fontWeight: 600,
    lineHeight: '28px'
  },
  'text-lg-bold': {
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '28px'
  },
  'text-md-regular': {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: '24px'
  },
  'text-md-medium': {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: '24px'
  },
  'text-md-light': {
    fontSize: '16px',
    fontWeight: 300,
    lineHeight: '24px'
  },
  'text-md-semibold': {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '24px'
  },
  'text-md-bold': {
    fontSize: '16px',
    fontWeight: 700,
    lineHeight: '24px'
  },
  'text-sm-regular': {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '20px'
  },
  'text-sm-medium': {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: '20px'
  },
  'text-sm-light': {
    fontSize: '14px',
    fontWeight: 300,
    lineHeight: '20px'
  },
  'text-sm-semibold': {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: '20px'
  },
  'text-sm-bold': {
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: '20px'
  },
  'text-xs-regular': {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '18px'
  },
  'text-xs-medium': {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: '18px'
  },
  'text-xs-light': {
    fontSize: '12px',
    fontWeight: 300,
    lineHeight: '18px'
  },
  'text-xs-semibold': {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '18px'
  },
  'text-xs-bold': {
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: '18px'
  }
};
var typography = exports.typography = (0, _extends2["default"])({}, baseValues, typographyVariants);